import React from 'react'
import { Navigate, useParams } from 'react-router-dom'

/** 레거시 URL 호환: 관리 상세 → 공개 상세 + 지원자 앵커 */
const JobPostManageDetailView = () => {
	const { postId } = useParams()
	if (!postId) return <Navigate to="/posts/manage" replace />
	return <Navigate to={{ pathname: `/posts/${postId}`, hash: 'job-post-applicants' }} replace />
}

export default JobPostManageDetailView
